var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.064 7.63199H12.936C11.1831 7.63199 9.76202 9.05304 9.76202 10.806V49.2C9.76202 50.9529 11.1831 52.374 12.936 52.374H47.064C48.817 52.374 50.238 50.9529 50.238 49.2V10.806C50.238 9.05304 48.817 7.63199 47.064 7.63199Z",
    fill: "#FF931E",
    stroke: "#FF931E",
    strokeWidth: 1.88,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.096 13.05H14.91C13.7436 13.05 12.798 13.9956 12.798 15.162V22.092C12.798 23.2584 13.7436 24.204 14.91 24.204H45.096C46.2625 24.204 47.208 23.2584 47.208 22.092V15.162C47.208 13.9956 46.2625 13.05 45.096 13.05Z",
    fill: "#FFF4DE",
    stroke: "#FFF4DE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.812 26.772H22.188C21.8898 26.772 21.648 27.0137 21.648 27.312V30.762C21.648 31.0602 21.8898 31.302 22.188 31.302H37.812C38.1102 31.302 38.352 31.0602 38.352 30.762V27.312C38.352 27.0137 38.1102 26.772 37.812 26.772Z",
    fill: "#17292C",
    stroke: "#17292C",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.316 16.866H16.548C16.22 16.866 15.954 17.1319 15.954 17.46V21.222C15.954 21.5501 16.22 21.816 16.548 21.816H17.316C17.6441 21.816 17.91 21.5501 17.91 21.222V17.46C17.91 17.1319 17.6441 16.866 17.316 16.866Z",
    fill: "#17292C",
    stroke: "#17292C",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.054 16.866H20.286C19.958 16.866 19.692 17.1319 19.692 17.46V21.222C19.692 21.5501 19.958 21.816 20.286 21.816H21.054C21.3821 21.816 21.648 21.5501 21.648 21.222V17.46C21.648 17.1319 21.3821 16.866 21.054 16.866Z",
    fill: "#17292C",
    stroke: "#17292C",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.786 16.866H24.018C23.69 16.866 23.424 17.1319 23.424 17.46V21.222C23.424 21.5501 23.69 21.816 24.018 21.816H24.786C25.1141 21.816 25.38 21.5501 25.38 21.222V17.46C25.38 17.1319 25.1141 16.866 24.786 16.866Z",
    fill: "#17292C",
    stroke: "#17292C",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5181 16.866H27.7501C27.422 16.866 27.1561 17.1319 27.1561 17.46V21.222C27.1561 21.5501 27.422 21.816 27.7501 21.816H28.5181C28.8461 21.816 29.1121 21.5501 29.1121 21.222V17.46C29.1121 17.1319 28.8461 16.866 28.5181 16.866Z",
    fill: "#17292C",
    stroke: "#17292C",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2501 16.866H31.4821C31.154 16.866 30.8881 17.1319 30.8881 17.46V21.222C30.8881 21.5501 31.154 21.816 31.4821 21.816H32.2501C32.5781 21.816 32.8441 21.5501 32.8441 21.222V17.46C32.8441 17.1319 32.5781 16.866 32.2501 16.866Z",
    fill: "#17292C",
    stroke: "#17292C",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9821 16.866H35.2141C34.886 16.866 34.6201 17.1319 34.6201 17.46V21.222C34.6201 21.5501 34.886 21.816 35.2141 21.816H35.9821C36.3101 21.816 36.5761 21.5501 36.5761 21.222V17.46C36.5761 17.1319 36.3101 16.866 35.9821 16.866Z",
    fill: "#FF4F40",
    stroke: "#FF4F40",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.72 16.866H38.952C38.624 16.866 38.358 17.1319 38.358 17.46V21.222C38.358 21.5501 38.624 21.816 38.952 21.816H39.72C40.0481 21.816 40.314 21.5501 40.314 21.222V17.46C40.314 17.1319 40.0481 16.866 39.72 16.866Z",
    fill: "#FF4F40",
    stroke: "#FF4F40",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.452 16.866H42.684C42.356 16.866 42.09 17.1319 42.09 17.46V21.222C42.09 21.5501 42.356 21.816 42.684 21.816H43.452C43.7801 21.816 44.046 21.5501 44.046 21.222V17.46C44.046 17.1319 43.7801 16.866 43.452 16.866Z",
    fill: "#FF4F40",
    stroke: "#FF4F40",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.12 25.104C48.378 32.292 48.516 39.636 48.612 46.836C48.696 48.57 47.22 50.184 45.474 50.256C42.516 50.31 39.66 50.304 36.75 50.316C30.954 50.328 25.158 50.292 19.368 50.208L15.024 50.136C14.274 50.166 13.362 49.926 12.768 49.41C11.79 48.666 11.478 47.358 11.616 46.212L11.652 45.126C11.736 43.02 11.778 40.698 11.892 38.61C11.988 40.698 12.066 43.026 12.132 45.126C12.192 45.72 12.132 46.698 12.228 47.256C12.444 48.582 13.698 49.476 15.03 49.32C22.23 49.182 29.568 49.122 36.762 49.14L45.42 49.182C46.632 49.146 47.652 48.066 47.634 46.842C47.718 39.642 47.874 32.304 48.126 25.11L48.12 25.104Z",
    fill: "#FFF4DE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.682 35.58L15.318 34.98L44.682 34.38V35.58Z",
    fill: "#FFF4DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmart);
export default __webpack_public_path__ + "static/media/smart.612a2bbbd8a9bba80707ae81585d933a.svg";
export { ForwardRef as ReactComponent };